import { Avatar, Col, Row } from 'ui';
import { useUser } from 'features/auth';
import { CommunitySelect, type CommunitySelectProperties } from '../community-select';
import { type CommunityLabelInValue, useCommunitySelectWithUserProfilePhotoCreateOption } from './hooks';

type P = Omit<CommunitySelectProperties<CommunityLabelInValue>, 'createOption'>;

const CommunitySelectWithUserProfilePhoto = ({ ...input }: P) => {
  const { railsUserData: viewer } = useUser();
  const createOption = useCommunitySelectWithUserProfilePhotoCreateOption();

  return (
    <Row justify="center">
      <Col alignItems="center" flex="0 0 50px">
        <Avatar photo={viewer.profilePhoto?.url} />
      </Col>
      <Col flex={1}>
        <CommunitySelect<CommunityLabelInValue>
          createOption={createOption}
          {...input}
          query={{ filter: { scope: 'postable' } }}
        />
      </Col>
    </Row>
  );
};

export default CommunitySelectWithUserProfilePhoto;

export { type CommunityLabelInValue } from './hooks';
